export interface SwipeGestureHandlers {
  onTouchStart: (event: TouchEvent) => void
  onTouchMove: (event: TouchEvent) => void
  onTouchEnd: (event: TouchEvent) => void
}

export interface SwipeGestureOptions {
  threshold?: number
  onSwipeLeft: () => void
  onSwipeRight: () => void
}

export function createSwipeGesture(options: SwipeGestureOptions): SwipeGestureHandlers {
  const threshold = options.threshold ?? 50

  let touchStartX = 0
  let touchStartY = 0
  let swipeCancelled = false

  return {
    onTouchStart(event: TouchEvent) {
      const touch = event.changedTouches[0]
      if (!touch) return
      touchStartX = touch.clientX
      touchStartY = touch.clientY
      swipeCancelled = false
    },

    onTouchMove(event: TouchEvent) {
      if (event.touches.length > 1 || event.defaultPrevented) {
        swipeCancelled = true
      }
    },

    onTouchEnd(event: TouchEvent) {
      if (swipeCancelled) return

      const touch = event.changedTouches[0]
      if (!touch) return

      const deltaX = touch.clientX - touchStartX
      const deltaY = touch.clientY - touchStartY

      if (Math.abs(deltaX) < threshold || Math.abs(deltaX) <= Math.abs(deltaY)) return

      if (deltaX < 0) {
        options.onSwipeLeft()
      } else {
        options.onSwipeRight()
      }
    },
  }
}
